'use strict';

/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/call-bind-apply-helpers/functionCall.js
// module id = 1047
// module chunks = 0